/**
 * Regras Omie para listagens de Indicadores KPI e Grupos financeiros:
 * excluir códigos tipo LIKE '9%' e descrições terminadas em '*'.
 */

const normalizeCategoryCode = (value) =>
  value === undefined || value === null ? "" : String(value).trim();

/**
 * @param {{ codCategoria?: string, descricao?: string }} cat
 * @returns {boolean}
 */
export function isOmieBlockedFinancialCategory(cat) {
  if (!cat) return false;
  const code = normalizeCategoryCode(cat.codCategoria);
  if (code.startsWith("9")) return true;
  const desc = cat.descricao != null ? String(cat.descricao).trim() : "";
  if (desc.endsWith("*")) return true;
  return false;
}

/**
 * @param {Array<{ codCategoria?: string, descricao?: string }>} categories
 * @returns {typeof categories}
 */
export function filterOmieFinancialCategories(categories) {
  if (!Array.isArray(categories)) return [];
  return categories.filter((c) => !isOmieBlockedFinancialCategory(c));
}

/**
 * Remove linhas de kpiConfig / financialGroupConfig que apontam para categorias bloqueadas no Omie.
 * @param {Array<Record<string, unknown>>} rows
 * @param {Array<{ codCategoria?: string, descricao?: string }>} categories lista completa da API (para resolver descrição)
 * @returns {typeof rows}
 */
export function filterOmieInvalidKpiOrGroupConfigRows(rows, categories) {
  if (!Array.isArray(rows)) return [];
  const byCode = new Map();
  (categories || []).forEach((c) => {
    const k = normalizeCategoryCode(c.codCategoria);
    if (k) byCode.set(k, c);
  });

  return rows.filter((item) => {
    const cod = normalizeCategoryCode(item.codCategoria || item.CodCategoria);
    if (!cod) return true;
    const cat = byCode.get(cod);
    if (cat) return !isOmieBlockedFinancialCategory(cat);
    return !cod.startsWith("9");
  });
}
